import React from "react";

import './load.css'

function Load() {
    return (
        <div class="spinner">
            <div class="bounce1"></div>
            <div class="bounce2"></div>
            <div class="bounce3"></div>
        </div>
    )
}

export default Load;